import { ActionReducerMapBuilder, createAsyncThunk } from "@reduxjs/toolkit";
import TruckService from "../../../service/truckService";
import { GraphQLClient } from "../../../../../../../shared/gql-client";
import { PlanningSliceModel } from "../../PlanningSlice";
import { TruckModel } from "../../../../domain/models/truckModel";

const truckApi = new TruckService();

export const getPlanningTrucks = createAsyncThunk(
  "planning/get/trucks",
  async (day: string | undefined, thunkAPI) => {
    const { client } = thunkAPI.extra as { client: GraphQLClient };

    try {
      truckApi.setClient(client);

      return await truckApi.getTrucks();
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);

export const extraReducersGetPlanningTrucks = (
  builder: ActionReducerMapBuilder<PlanningSliceModel>,
) => {
  builder.addCase(getPlanningTrucks.pending, (state) => {
    state.loading = true;
  });
  builder.addCase(getPlanningTrucks.fulfilled, (state, action) => {
    state.loading = false;
    state.trucks = action.payload as TruckModel[];
  });
};
